import { applyInterceptors } from './util/axios/interceptors.axios'
import { axiosInstance } from './util/axios/instance.axios'
import { renderApp } from './model/React'
import { AppProvider } from './component/unique/provider/AppProvider'
import { App } from './component/unique/organism/App'

const RESIZE_OBSERVER_LOOP_ERROR = 'ResizeObserver loop completed with undelivered notifications.'

const suppressResizeObserverOverlayNoise = () => {
  if (process.env.NODE_ENV !== 'development') {
    return
  }

  window.addEventListener('error', (event) => {
    if (event.message === RESIZE_OBSERVER_LOOP_ERROR) {
      event.stopImmediatePropagation()
    }
  })

  window.addEventListener('unhandledrejection', (event) => {
    const reasonMessage = event.reason instanceof Error ? event.reason.message : String(event.reason || '')

    if (reasonMessage === RESIZE_OBSERVER_LOOP_ERROR) {
      event.preventDefault()
    }
  })
}

applyInterceptors(axiosInstance)
suppressResizeObserverOverlayNoise()

renderApp(
  <AppProvider>
    <App/>
  </AppProvider>,
)